import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { reducers as confirmPaymentReducers } from './confirmPayment.reducers';
import { CadenceTypes } from '../../../components/auth/proRegister/cadenceSelector';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';

interface IPaymentData {
  amount: number;
  cadence: CadenceTypes;
}

export interface IConfirmPaymentState {
  loading: boolean;
  amount: number;
  cadence: CadenceTypes;
}
const initialState: IConfirmPaymentState = {
  loading: false,
  amount: 0,
  cadence: CadenceTypes.MONTHLY
};

const confirmPaymentSlice = createSlice({
  name: 'confirmPayment',
  initialState,
  reducers: {
    setPaymentData: (state, action: PayloadAction<IPaymentData>) => {
      if (isFeatureEnabled(Features.PlgExternal)) {
        state.amount = action.payload.amount;
        state.cadence = action.payload.cadence;
      }
    }
  },
  extraReducers: {
    ...confirmPaymentReducers
  }
});

export const {
  setPaymentData
} = confirmPaymentSlice.actions;

export default confirmPaymentSlice.reducer;